import { INVIS, InvisSettingsView } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';
import { useNavigate } from 'react-router-dom';

/** Settings · AI Brain › Invisalign Coordinator (spec 16 §11, amendment 33 §3). */
export function SettingsInvisPage() {
  const navigate = useNavigate();
  return (
    <InvisSettingsView
      data={INVIS}
      location={useWorkspaceLabel()}
      onOpenStep={(step) => { void navigate(`/settings/ai/invisalign/programme/${step}`); }}
    />
  );
}
